
import { toast } from 'sonner';
import { soundSystem } from '@/utils/sounds/SoundNotificationSystem';

export const enhancedToast = {
  success: (message: string, description?: string) => {
    console.log('🎉 Enhanced toast success:', message);
    soundSystem.playSound('success');
    return toast.success(message, { description });
  },

  error: (message: string, description?: string) => {
    console.log('❌ Enhanced toast error:', message);
    soundSystem.playSound('error');
    return toast.error(message, { description });
  },

  warning: (message: string, description?: string) => {
    console.log('⚠️ Enhanced toast warning:', message);
    soundSystem.playSound('warning');
    return toast(message, { description });
  },

  info: (message: string, description?: string) => {
    console.log('ℹ️ Enhanced toast info:', message);
    soundSystem.playSound('info');
    return toast(message, { description });
  },

  download: (message: string, description?: string) => {
    console.log('📥 Enhanced toast download:', message);
    soundSystem.playSound('download');
    return toast.success(message, { description });
  },

  loading: (message: string, description?: string) => {
    console.log('⏳ Enhanced toast loading:', message);
    return toast.loading(message, { description });
  },

  dismiss: (toastId?: string | number) => {
    return toast.dismiss(toastId);
  },

  // Test method to verify sound system
  testSound: (type: 'success' | 'error' | 'warning' | 'info' | 'download' = 'success') => {
    console.log(`🧪 Testing enhanced toast with ${type} sound...`);
    soundSystem.testSound(type);
    
    switch (type) {
      case 'success':
        return enhancedToast.success('Test Success Notification', 'This is a test success message');
      case 'error':
        return enhancedToast.error('Test Error Notification', 'This is a test error message');
      case 'warning':
        return enhancedToast.warning('Test Warning Notification', 'This is a test warning message');
      case 'info':
        return enhancedToast.info('Test Info Notification', 'This is a test info message');
      case 'download':
        return enhancedToast.download('Test Download Notification', 'This is a test download message');
    }
  }
};
